import gql from 'graphql-tag'

// USED IN: VEIL
export const GetNotePDF = gql`
  query GetNotePDF($compositionId: ID, $noteId: ID) {
    notePDF(input: {
      compositionId: $compositionId,
      noteId: $noteId
    }) {
      pdf {
        uri
      }
    }
  }
`

export const BulkPrintPDFs = gql`
  query BulkPrintPDFs($compositionIds: [ID], $patientNoteIds: [ID]) {
    bulkPrintPDFs(input: {
      compositionIds: $compositionIds,
      patientNoteIds: $patientNoteIds
    }) {
      pdf {
        uri
      }
    }
  }
`

export const BulkSavePDFs = gql`
  query BulkSavePDFs($compositionIds: [ID], $patientNoteIds: [ID]) {
    bulkSavePDFs(input: {
      compositionIds: $compositionIds,
      patientNoteIds: $patientNoteIds
    }) {
      zip {
        uri
      }
    }
  }
`
